import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Popover } from 'antd';
import {
  getCurrentPrioVersion,
  getZendeskDrawerOpen,
} from '../../../apps/main/rootReducer';
import { useTranslation } from 'react-i18next';
import {
  openZendeskDrawer,
  updateZendeskDrawerView,
  ZendeskDrawerView,
} from '../actions/drawer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from '../../../components/Flex';
import DataRefreshForm from './DataRefreshForm';
import { useTheme } from 'react-jss';
import { PrioTheme } from '../../../theme/types';
import { Drawer } from '@prio365/prio365-react-library';
import ZendeskWidgetHelpForm from './ZendeskWidgetHelp';
import ZendeskWidgetReport from './ZendeskWidgetReport';
import PrioStatus from './PrioStatus';
import { makePrioStyles } from '../../../theme/utils';

const useStyles = makePrioStyles((theme: PrioTheme) => ({
  root: {},
  infoIcon: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

interface GlobalZendeskDrawerProps {
  className?: string;
}

export const GlobalZendeskDrawer: React.FC<GlobalZendeskDrawerProps> = (
  props
) => {
  const { className } = props;
  const theme = useTheme<PrioTheme>();
  const open = useSelector(getZendeskDrawerOpen);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();

  const closeDrawer = () => dispatch(openZendeskDrawer(false));

  const prioVersion = useSelector(getCurrentPrioVersion);

  return (
    <Drawer
      className={className}
      closable={true}
      onClose={closeDrawer}
      visible={open}
      title={
        <Flex.Row
          alignItems="baseline"
          childrenGap={theme.old.spacing.baseSpacing}
        >
          {t('zendesk:drawer.title')}
          <Popover
            title={t('zendesk:appVersion', {
              version: prioVersion,
            })}
            content={<DataRefreshForm />}
            trigger="click"
          >
            <FontAwesomeIcon
              className={classes.infoIcon}
              icon={['fal', 'info-circle']}
              size="sm"
            />
          </Popover>
        </Flex.Row>
      }
      tabs={[
        {
          key: 'help',
          label: t('zendesk:drawer.tabs.functions'),
          content: <ZendeskWidgetHelpForm />,
        },
        {
          key: 'report',
          label: t('zendesk:drawer.tabs.report'),
          content: <ZendeskWidgetReport />,
        },
        {
          key: 'prioStatus',
          label: t('zendesk:drawer.tabs.prioStatus'),
          content: <PrioStatus />,
        },
        /* TBD - Uncomment when FAQ is ready
        {
          key: 'faq',
          label: t('zendesk:drawer.tabs.faq'),
          content: <ZendeskWidgetFaq />,
        },
        */
      ]}
      onTabChange={(key) => {
        dispatch(updateZendeskDrawerView(key as ZendeskDrawerView));
      }}
    ></Drawer>
  );
};

export default GlobalZendeskDrawer;
